import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {WriteTaskForm} from "@/pages/Task/WriteTask";
import {SearchBO} from "@/service/common.s";
import {PlanPO, TaskPO} from "@/model/mission";
import {PlanEnum, SearchPlanVO} from "@/service/plan.s";
import {WritePlanForm} from "@/pages/Plan/WritePlan";

export enum TaskEnum {
    GetTaskPage = "/task/getTaskPage",
    GetTask = "/task/getTask",
    CreateTask = "/task/createTask",
    GetAllTask = "/task/getAllTask",
    GetTaskTree = "/task/getTaskTree",
    GetTaskBoard = "/task/getTaskBoard",
    SearchTask = "/task/searchTask",
    UpdateTask = "/task/updateTask",
}

export interface TaskPageBO {
    keyword?: string;
}

export interface SearchTaskVO extends TaskPO {
    names: string;
}

export interface TaskPageVO extends TaskPO {
}

export interface AllTaskBO {
    parentId: number
}

export interface AllTaskVO {
    taskName: string;
    id: number
}

export interface TaskTreeVO {
    id: number;
    parentId: number;
    taskName: string;
    children: TaskTreeVO[];
    planName: string;
    startDate: Date;
    collapsed: boolean;
    ratio: number,
    endDate: Date;
    executors: string;
}

export interface TaskBoardVO {
    [key: string]: PaginationVO<TaskPO>;
}

export interface TaskBoardBO extends PaginationBO {
    statusId: number
}

export const useQueryTaskPage = () => useMutation<BaseVO<PaginationVO<TaskPageVO>>, null, TaskPageBO>({
    mutationFn: (data: TaskPageBO) => http.post<BaseVO<PaginationVO<TaskPageVO>>>({
        url: TaskEnum.GetTaskPage,
        data: data,
    }),
})

export const useQueryTask = (params: GetByIdBO, enabled: boolean) => useQuery<BaseVO<TaskPO>>({
    queryKey: [params.id], enabled, queryFn: () => http.get<BaseVO<TaskPO>>({
        url: TaskEnum.GetTask,
        params: params
    })
})

export const useCreateTask = () => useMutation({
    mutationFn: (data: WriteTaskForm) => http.put<BaseVO<null>>({url: TaskEnum.CreateTask, data}),
})

export const useQueryAllTask = (data: AllTaskBO, enabled: boolean) => useQuery({
    queryKey: ["allTask"],
    enabled,
    queryFn: () => http.post<BaseVO<AllTaskVO[]>>({
        url: TaskEnum.GetAllTask,
        data
    })
})

export const useQueryTaskTree = () => useMutation({mutationFn: (data: SearchBO) => http.post<BaseVO<TaskTreeVO[]>>({url: TaskEnum.GetTaskTree, data})})

export interface SearchTaskVO {
    taskName: string;
    id: number
    duration: number
    planStageId: number
    planStage: string
    priorityId: number
    priority: string
    status: string
    statusId: number
}

export const useUpdateTask = () => useMutation({
    mutationFn: (data: WriteTaskForm) => http.post<BaseVO<null>>({url: TaskEnum.UpdateTask, data}),
})

export const useQueryTaskBoard = () => useMutation({
    mutationFn: (data: TaskBoardBO) => http.post<BaseVO<TaskBoardVO>>({
        url: TaskEnum.GetTaskBoard,
        data
    })
})

export const useSearchTask = () => useMutation({
    mutationFn: (data: SearchBO) => http.post<BaseVO<SearchTaskVO[]>>({url: TaskEnum.SearchTask, data})
})


